// Import jQuery for DOM manipulation
import $ from 'jquery';
import { closeModal } from '../../utils/modal-helpers';

/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
window.CompanyUsers = {
  initializeCompanyUsersGrid(tableSelector, users) {
    const gridOptions = {
      paginationPageSize: 10,
      headerHeight: 44,
      rowHeight: 44,
      columnDefs: this._columnDefs(),
      rowData: users,
      defaultColDef: {
        sortable: true,
        resizable: true
      },
      onGridReady(event) {
        event.api.sizeColumnsToFit();
        return $('[data-powertip]').powerTip();
      },
      onGridSizeChanged(event) {
        return event.api.sizeColumnsToFit();
      }
    };

    const gridDiv = document.getElementById(tableSelector);
    const gridApi = agGrid.createGrid(gridDiv, gridOptions);
    gridOptions.api = gridApi;
    resizeAgGridTable(`#${tableSelector}`, gridOptions, 0, false, false, 20);
    return gridApi.sizeColumnsToFit();
  },

  _columnDefs() {
    return [
      { headerName: I18n.t('v4.company_settings.users.users.name'), field: 'name', cellClass: 'cell' },
      { headerName: I18n.t('v4.company_settings.users.users.title'), field: 'job_title', cellClass: 'cell' },
      { headerName: I18n.t('v4.company_settings.users.users.email'), field: 'email', cellClass: 'cell' },
      { headerName: I18n.t('v4.company_settings.users.users.roles'), field: 'roles', cellClass: 'cell' },
      { headerName: I18n.t('v4.company_settings.users.users.status'), field: 'status', cellClass: 'cell' },
      { headerName: I18n.t('v4.company_settings.users.users.login_count'), field: 'login_count', cellClass: 'cell' },
      { headerName: I18n.t('v4.company_settings.users.users.created_at'), field: 'created_at', cellClass: 'cell', comparator: this._dateStringComperator },
      { headerName: I18n.t('v4.company_settings.users.users.last_login'), field: 'last_sign_in_at', cellClass: 'cell', comparator: this._dateStringComperator },
      { headerName: I18n.t('v4.company_settings.users.users.actions'), cellClass: 'cell', width: 100, sortable: false, suppressSizeToFit: true, cellRenderer: this._renderActions }
    ];
  },

  _dateStringComperator(firstDate, secondDate) {
    firstDate = new Date(firstDate);
    secondDate = new Date(secondDate);
    return firstDate - secondDate;
  },

  _renderActions(params) {
    return `<div class='row-actions' data-id='${params.data.id}'>` +
      `<span data-powertip='${I18n.t('delete')}'><a data-reveal-id='delete-user' data-reveal-ajax='true' href='/workplace/company/users/${params.data.id}/participation_details.html' class='button nano icon-btn pt-delete' data-user-id='${params.data.id}'></a></span>` +
      `<span data-powertip='${I18n.t('edit')}'><a class='button nano icon-btn pt-edit' data-user-id='${params.data.id}' href='/workplace/company/users/${params.data.id}/edit_colleague'></a></span>` +
      "</div>";
  }
};

$(document).on('click', '#purchase-user-license', function (e) {
  if (!jQuery.hasData($(this))) {
    e.preventDefault();
    // Note: No need to import openModal since we only close in this file
    return $('#purchase-user-licenses-modal').foundation('reveal', 'open');
  }
});
